'use strict';

(function (global) {

  /**
   * @class ImageDocumentPostprocessor
   * @classdesc Подготовка к предпросмотру изображений.
   * @hideconstructor
   * @namespace window.Core.preview
   * @since 5.7.0
   */
  class ImageDocumentPostprocessor extends global.BaseDocumentPostprocessor {

    // Костыль для IE10, иначе он не может наследовать родительский static метод с babel-preset-env 1.6.1
    /**
     * @see BaseDocumentPostprocessor.prepare
     */
    static prepare(jFrame, filePath, extension) {
      return super.prepare(jFrame, filePath, extension);
    }

    // Костыль для IE10, иначе он не может наследовать родительский static метод с babel-preset-env 1.6.1
    /**
     * @see BaseDocumentPostprocessor._addFilesToHead
     */
    static _addFilesToHead(jFrameContents, filePath) {
      return super._addFilesToHead(jFrameContents, filePath);
    }

    /**
     * @see BaseDocumentPostprocessor._prepareContents
     */
    static _prepareContents(jFrame) {
      $('canvas', jFrame[0].contentDocument)
        .wrap('<div id="placeholder_1" class="placeholder current primary">');
    }
  }

  global.ImageDocumentPostprocessor = ImageDocumentPostprocessor;

})(window.Core.preview);